<template>
  <div>
    <h3 style="text-align: center">选择短信模板</h3>
    <div>
      <a-tabs defaultActiveKey="0" @change="tabCallback">
        <a-tab-pane tab="顾问-英语" key="0">
          <div>
            <a v-for="list in SmsList['顾问-英语']" :key="list.id" @click="selectSMSTEM(list.channel + '_' + list.id)"
              :id="list.channel + '_' + list.id" class="list-group-item">
              <h5 class="list-group-item-heading">{{ list.title }}</h5>
              {{
              list.smstitle == "-1" || list.smstitle == ""
              ? ""
              : "【" + list.smstitle + "】" + list.context
              }}
            </a>
          </div>
        </a-tab-pane>
        <a-tab-pane tab="学管-英语" key="1" forceRender>
          <div>
            <a v-for="list in SmsList['学管-英语']" :key="list.id" @click="selectSMSTEM(list.channel + '_' + list.id)"
              :id="list.channel + '_' + list.id" class="list-group-item">
              <h5 class="list-group-item-heading">{{ list.title }}</h5>
              {{
              list.smstitle == "-1" || list.smstitle == ""
              ? ""
              : "【" + list.smstitle + "】" + list.context
              }}
            </a>
          </div>
        </a-tab-pane>
        <a-tab-pane tab="客服-英语" key="2" forceRender>
          <div>
            <a v-for="list in SmsList['客服-英语']" :key="list.id" @click="selectSMSTEM(list.channel + '_' + list.id)"
              :id="list.channel + '_' + list.id" class="list-group-item">
              <h5 class="list-group-item-heading">{{ list.title }}</h5>
              {{
              list.smstitle == "-1" || list.smstitle == ""
              ? ""
              : "【" + list.smstitle + "】" + list.context
              }}
            </a>
          </div>
        </a-tab-pane>
        <a-tab-pane tab="顾问-思维" key="3" forceRender>
          <div>
            <a v-for="list in SmsList['顾问-思维']" :key="list.id" @click="selectSMSTEM(list.channel + '_' + list.id)"
              :id="list.channel + '_' + list.id" class="list-group-item">
              <h5 class="list-group-item-heading">{{ list.title }}</h5>
              {{
              list.smstitle == "-1" || list.smstitle == ""
              ? ""
              : "【" + list.smstitle + "】" + list.context
              }}
            </a>
          </div>
        </a-tab-pane>
        <a-tab-pane tab="客服-思维" key="4" forceRender>
          <a v-for="list in SmsList['客服-思维']" :key="list.id" @click="selectSMSTEM(list.channel + '_' + list.id)"
            :id="list.channel + '_' + list.id" class="list-group-item">
            <h5 class="list-group-item-heading">{{ list.title }}</h5>
            {{
            list.smstitle == "-1" || list.smstitle == ""
            ? ""
            : "【" + list.smstitle + "】" + list.context
            }}
          </a>
        </a-tab-pane>
        <a-tab-pane tab="顾问-美术" key="5">
          <a v-for="list in SmsList['顾问-美术']" :key="list.id" @click="selectSMSTEM(list.channel + '_' + list.id)"
            :id="list.channel + '_' + list.id" class="list-group-item">
            <h5 class="list-group-item-heading">{{ list.title }}</h5>
            {{
            list.smstitle == "-1" || list.smstitle == ""
            ? ""
            : "【" + list.smstitle + "】" + list.context
            }}
          </a>
        </a-tab-pane>
        <a-tab-pane tab="客服-美术" key="6">
          <a v-for="list in SmsList['客服-美术']" :key="list.id" @click="selectSMSTEM(list.channel + '_' + list.id)"
            :id="list.channel + '_' + list.id" class="list-group-item">
            <h5 class="list-group-item-heading">{{ list.title }}</h5>
            {{
            list.smstitle == "-1" || list.smstitle == ""
            ? ""
            : "【" + list.smstitle + "】" + list.context
            }}
          </a>
        </a-tab-pane>
        <a-tab-pane tab="国际短信" key="7" forceRender>
          <div>
            <a @click="selectSMSTEM('SMS_250335086')" id="SMS_250335086" class="list-group-item">
              <h5 class="list-group-item-heading">上课提醒</h5>
              학부모님 안녕하세요. 오늘 저녁 ${time} 에 ${name} 는 수업이 있다는 것을 잊지 마시길 바랍니다.
            </a>
            <a @click="selectSMSTEM('SMS_209837256')" id="SMS_209837256" class="list-group-item">
              <h5 class="list-group-item-heading">注册未购买激活</h5>
              尊敬的家长，您的${info}已经到账，微信公众号留言“${msg}”详情咨询助教老师:${phone}微信同号。
            </a>
            <a @click="selectSMSTEM('SMS_208582492')" id="SMS_208582492" class="list-group-item">
              <h5 class="list-group-item-heading">注册未购买当天</h5>
              家长您好，我是久趣英语客服${name}，您在${day}报名了英语课程，关于课程安排详情我将通过微信发给您，${phone}微信同号。
            </a>
            <a @click="selectSMSTEM('SMS_208627202')" id="SMS_208627202" class="list-group-item">
              <h5 class="list-group-item-heading">注册未购买第7天</h5>
              家长您好，我是久趣英语助教老师，专门负责孩子的学习安排，您于${time}报名了${name}课程。您看安排哪天上课比较合适？老师联系方式：${phone}微信同号。
            </a>
            <a @click="selectSMSTEM('SMS_208637168')" id="SMS_208637168" class="list-group-item">
              <h5 class="list-group-item-heading">1104购买当天</h5>
              家长您好，我是久趣${name}老师是负责给孩子安排上课的以及之后您有课程疑问都可以咨询我，您购买的${product}，开课时间：${day}，麻烦您添加一下我哈，发下上课流程您。老师联系方式：${phone}微信同号。
            </a>
            <a @click="selectSMSTEM('SMS_208642187')" id="SMS_208642187" class="list-group-item">
              <h5 class="list-group-item-heading">1104购买第2天</h5>
              家长您好，我是久趣英语助教老师，专门负责孩子的学习安排，给您致电无人接听；您给孩子购买的${productname}的体验课包有效期是1个月；请问安排哪天上课比较合适？老师联系方式：${phone}微信同号
            </a>
            <a @click="selectSMSTEM('SMS_208582496')" id="SMS_208582496" class="list-group-item">
              <h5 class="list-group-item-heading">1104购买第5天</h5>
              家长您好，我是久趣英语助教老师，一直没有联系上您，您给孩子报名了久趣英语直播课，建议尽快给孩子预约下体验课程。我是孩子的助教老师，麻烦您添加我微信${phone}
            </a>
            <a @click="selectSMSTEM('SMS_208582501')" id="SMS_208582501" class="list-group-item">
              <h5 class="list-group-item-heading">未关注绑定公众号</h5>
              久趣学员您好，上课需要通过微信关注“久趣英语服务号”预约时间，并用ipad下载“久趣英语”上课。详情可咨询客服${phone}微信同号
            </a>
            <a @click="selectSMSTEM('SMS_206751122')" id="SMS_206751122" class="list-group-item">
              <h5 class="list-group-item-heading">港澳台-首访失败/二访失败</h5>
              ${name}家长您好！我是孩子在久趣英语的班主任${teacher}老师。刚才给您致电话，没有接通，以后我会跟踪以及反馈孩子在久趣期间的英语学习情况，今天想在电话里向您了解一下孩子近期的上课情况。您可以告诉我您方便的时间，我再给您致电，我的手机号码是：${phone}(备注：${msg})，（微信同号）请您注意保存或可以添加我的微信，期待宝贝的进步。
            </a>
            <a @click="selectSMSTEM('SMS_206550258')" id="SMS_206550258" class="list-group-item">
              <h5 class="list-group-item-heading">顾问-香港注册未购买</h5>
              家长您好，我是久趣英语客服${name}，您在${day}报名了英语课程，关于课程安排详情我将通过微信发给您，${phone}微信同号。
            </a>
            <a @click="selectSMSTEM('SMS_202566387')" id="SMS_202566387" class="list-group-item">
              <h5 class="list-group-item-heading">顾问-香港用户开课通知</h5>
              家长您好，我是久趣${name}老师是负责给孩子安排上课的以及之后您有课程疑问都可以咨询我，您购买的${product}，开课时间：${day}，麻烦您添加一下我哈，发下上课流程您。老师联系方式：${phone}微信同号。
            </a>
            <a @click="selectSMSTEM('SMS_202566388')" id="SMS_202566388" class="list-group-item">
              <h5 class="list-group-item-heading">顾问-香港反馈收集</h5>
              家长您好，我是久趣英语助教老师，专门负责孩子的学习安排，小朋友有上了咱们体验课程，想跟您做一个简单的学习反馈，以便于协助孩子更好的上课。详情咨询助教老师：${phone}微信同号。
            </a>
            <a @click="selectSMSTEM('SMS_202546641')" id="SMS_202546641" class="list-group-item">
              <h5 class="list-group-item-heading">顾问-香港用户课程规划</h5>
              家长您好，我是久趣英语助教老师，专门负责孩子的学习安排，这边看到孩子的体验课已经学完了。如果接下来有规划给孩子继续上这个课程的话，详情咨询助教老师：${phone}微信同号。
            </a>
            <a @click="selectSMSTEM('SMS_202546642')" id="SMS_202546642" class="list-group-item">
              <h5 class="list-group-item-heading">顾问-特权到账通知</h5>
              尊敬的家长，您的${product}优惠（优惠内容:${info}）已经到账，微信公众号回复“${msg}”详情咨询助教老师:${phone}微信同号。
            </a>
            <a @click="selectSMSTEM('SMS_201455546')" id="SMS_201455546" class="list-group-item">
              <h5 class="list-group-item-heading">Trial Invitation SMS</h5>
              Congratulations! You have successfully registered for the Qkids
              Phonics Free Trial and taken the first step to jump start your
              child’s literacy foundation! To schedule your classes, please
              email us at qkidscourse@qkids.com with your phone number, student
              name and age. Please note this quick scheduling step is important
              as our new trial classes will start within the next few days. See
              you in class! -Qkids Team
            </a>
            <a @click="selectSMSTEM('SMS_201455548')" id="SMS_201455548" class="list-group-item">
              <h5 class="list-group-item-heading">
                Reminder for Free Trial SMS
              </h5>
              Hello, early reader parent! This is a reminder that you have
              registered for two free lesson credits with Qkids Phonics Program.
              This is a total savings of $30! You can quickly schedule your
              classes by sending us an email at qkidscourse@qkids.com with your
              phone number, student name and age. Please note this step is
              important as our new trial class will start within the next few
              days. Qkids Team
            </a>
            <a @click="selectSMSTEM('SMS_201450609')" id="SMS_201450609" class="list-group-item">
              <h5 class="list-group-item-heading">
                Trial is Expiring Soon SMS
              </h5>
              We know life is hectic with children at home, but we don’t want
              you to miss your opportunity to start off on the best path
              possible for your child’s reading career. Please contact us via
              email at Qkidscourse@qkids.com, so our team will be able to
              quickly schedule the trial classes for you in just a few simple
              steps. Qkids Team.
            </a>
            <a @click="selectSMSTEM('SMS_201455554')" id="SMS_201455554" class="list-group-item">
              <h5 class="list-group-item-heading">Trial Expires in 1 Day</h5>
              Oh no! Your $30 savings for 2 free classes expires in one day. To
              claim them, simply email qkidscourse@qkids.com and quickly
              schedule your classes today!
            </a>
            <a @click="selectSMSTEM('SMS_191195003')" id="SMS_191195003" class="list-group-item">
              <h5 class="list-group-item-heading">北美试用申请</h5>
              Hi, thanks for your application with Qkids Phonics Free Trial. To
              schedule your classes, please email us at qkidscourse@qkids.com
              with your registered phone number, student name and age. Please
              note this is important as our new trial class will start within
              next few days. Qkids Team for North Americas
            </a>
            <a @click="selectSMSTEM('SMS_191195004')" id="SMS_191195004" class="list-group-item">
              <h5 class="list-group-item-heading">学分即将过期提醒</h5>
              Hi, this is the reminder that you have successfully applied for
              two free lesson credits with Qkids Phonics Program. The credit
              will expire soon. Please contact us via email at
              Qkidscourse@qkids.com ASAP, so our team will be able to schedule
              the trial classes for you. Qkids Team for North Americas.
            </a>
            <a @click="selectSMSTEM('SMS_190266168')" id="SMS_190266168" class="list-group-item">
              <h5 class="list-group-item-heading">课程确认及安装帮助</h5>
              We have confirmed your subscription to Qkids Phonics Program
              ${number} lesson package. Please download Qkids Student App via
              bit.ly/2Z2oIWH . Our customer representative team will reach out
              to you shortly. For any questions, you may contact us by email at
              Qkidscourse@qkids.com, or search Facebook @qkidscourse
            </a>
            <a @click="selectSMSTEM('SMS_188993708')" id="SMS_188993708" class="list-group-item">
              <h5 class="list-group-item-heading">韩国体验课</h5>
              북미원어민 화상수업 1회 무료체험 쿠폰을 발송해 드렸습니다. 예약용
              앱을 다운받아 원하는 시간에 예약해 보세요~
              https://qkids.com/activity/kr/download 클릭하고 다운받기
            </a>
          </div>
        </a-tab-pane>
        <a-tab-pane tab="国际-日韩" key="8">
          <a @click="selectSMSTEM('SMS_239325211')" id="SMS_239325211" class="list-group-item">
            <h5 class="list-group-item-heading">
              二十二、官网目前仅售卖外教1对1的体验课及年课包
            </h5>
            이 밖에 우리 회사 경영 모드 변경하기 때문에 앞으로 1대 1의 수업
            형식으로 할 겁니다. 불편을 해 드려서 죄송합니다. 다른 문제가
            있으시면 고객 서비스 센터로 연락해 주시기를 바랍니다. ^^
          </a>
          <a @click="selectSMSTEM('SMS_239320189')" id="SMS_239320189" class="list-group-item">
            <h5 class="list-group-item-heading">
              二十一、韩国VIP用户课时于近期上完，引导于官网再次购买课包
            </h5>

            학부모님 안녕하십니까? 여기는 Qkids English 고객 서비스 센터입니다.
            ${day}에 구매하셨던 Qkids 수업 패키지는 이미 다 완성했습니다. 이
            동안 아이는 수업에 적극적으로 참여해 주셔서 감사합니다. 부모님과
            아이는 우리 수업을 좋아한다면 Qkids English에서 계속 공부하시기를
            바랍니다. 수업을 다시 신청하고 싶으시면 우리 회사 홈페이지에서
            http://qkids.com/kr/ 수업 패키지를 구매하실 수 있습니다.
          </a>
          <a @click="selectSMSTEM('SMS_227905153')" id="SMS_227905153" class="list-group-item">
            <h5 class="list-group-item-heading">
              韩国-1对1课程上线，提示家长领取免费1课时
            </h5>
            부모님 안녕하세요. Qkids English 1대 1 수업은 정식으로 출시합니다.
            서비스로 우리 홈페이지에서 무료 체험으로 1:1수업 1회를 수령할 수
            있습니다. 더 많은 정보를 알고 싶으시다면 고객 서비스 센터로 연락해
            주시기를 바랍니다. ^^
          </a>
          <a @click="selectSMSTEM('SMS_225389875')" id="SMS_225389875" class="list-group-item">
            <h5 class="list-group-item-heading">
              韩国-免费体验课已上完，提示可报名大课包
            </h5>
            학부모님 안녕하십니까? 여기는 Qkids English 고객 서비스 센터입니다.
            아이는 무료 체험 수업을 이미 완성했습니다. 아이는 너무 잘하고 영어
            공부하는 능력이 강하고 ‘북미 원어민 영어 수업’에 빠르게
            적응했습니다. 그리고 수업 시간에 적극적으로 과정를 참여했습니다.
            수업 패키지를 신청하고 싶으시면 우리의 홈페이지 http://qkids.com/kr/
            에 들어가고 수업을 직접적으로 구매해도 되십니다. 문제가 있으면
            [Qkids Parents]앱에 들어가고 Qkids 고객 서비스에게 말을 남겨 주거나
            이메일로 service_kr@qkids.com 저희에게 연락하시면 됩니다.
          </a>
          <a @click="selectSMSTEM('SMS_229645395')" id="SMS_229645395" class="list-group-item">
            <h5 class="list-group-item-heading">韩国-免费课时约课提醒</h5>

            귀한 학부모님 안녕하십니까? 저는 Qkids English 고객 서비스 센터의
            Angel라고 합니다. 학부모님이 ${day}에 무료 체험 수업을 수령
            성공했습니다. 무료 체험 수업의 유효기간은 14일입니다. ${passtime}
            내에 사용해야 합니다. 수업 예약을 하지 않는 것 보니 어떻게 수업을
            하는지 좀 모릅니까? 문제가 있으면 [Qkids Parents]앱에 들어가고 Qkids
            고객 서비스에게 말을 남겨 주거나 이메일로 service_kr@qkids.com
            저희에게 연락하시면 됩니다.
          </a>
          <a @click="selectSMSTEM('SMS_225390614')" id="SMS_225390614" class="list-group-item">
            <h5 class="list-group-item-heading">韩国-注册未领取免费课时</h5>
            귀한 학부모님 안녕하십니까? 저는 Qkids English 고객 서비스 센터의
            Angel라고 합니다. 학부모님이 ${day}에 Qkids 학습 계정을
            등록하셨습니다. 지금은 https://qkids.com/kr/ 에 들어가서 체험 수업
            1회를 무료로 수령할 수 있습니다. 문제가 있으면 핸드폰에서 [Qkids
            Parents]앱을 다운하고 들어가서 Qkids 고객 서비스에게 말을 남겨
            주거나 이메일로 service_kr@qkids.com 저희에게 연락하시면 됩니다.
          </a>
          <a @click="selectSMSTEM('SMS_223540426')" id="SMS_223540426" class="list-group-item">
            <h5 class="list-group-item-heading">近期缺席情况比较多</h5>
            부모님 안녕하세요. 이 달에는 아이가 수업에 결석하는 경우가 좀 많은데
            온라인으로 수업하기 때문에 제시간에 교실에 들어오면 학습 효과가 더
            좋을 것 같습니다. 시간이 있으시면 아이가 제시간에 교실로 들어오도록
            독촉해 주시기를 바랍니다. 감사합니다. ^^
          </a>
          <a @click="selectSMSTEM('SMS_223540427')" id="SMS_223540427" class="list-group-item">
            <h5 class="list-group-item-heading">较长一段时间未约课</h5>
            부모님 안녕하세요. 아이가 요즘 수업에 나오지 않는데 온라인으로
            수업하기 때문에 유지해서 수업을 하는 것이 매우 중요하다고 합니다.
            시간이 있으시면 아이가 영어 공부를 하도록 독촉해 주시기를 바랍니다.
            감사합니다. ^^
          </a>
          <a @click="selectSMSTEM('SMS_223585353')" id="SMS_223585353" class="list-group-item">
            <h5 class="list-group-item-heading">
              提示我们的客服中心已从Kakao channel移至家长端
            </h5>
            Qkids 예약앱이 업그레이드 되었습니다^^ 핸드폰에서 구글 플레이나 애플
            스토어에 들어가 [Qkids English]를 검색하시고 업그레이드 해주세요~
            앞으로 모든 상담문의는 앱을 통해서 진행됩니다. 예약앱에
            로그인하시고「홈」화면 오른쪽 윗측 상단 마이크를 클릭하시면
            고객센터로 직접 연결됩니다. 카카오 채널은 더이상 오픈이 안되니
            유의해 주시기 바랍니다~
          </a>
          <a @click="selectSMSTEM('SMS_223580369')" id="SMS_223580369" class="list-group-item">
            <h5 class="list-group-item-heading">提示家长查看app内有新消息</h5>
            부모님 안녕하세요. Qkids English 고객 서비스 센터입니다. Qkids
            Parents 앱에 메시지를 남겨 드렸습니다. 시간이 있으시면 확인하시기
            바랍니다.
          </a>
          <a @click="selectSMSTEM('SMS_217425822')" id="SMS_217425822" class="list-group-item">
            <h5 class="list-group-item-heading">韩国-告知VIP用户有新活动</h5>
            부모님 안녕하세요. 저희 Qkids English는 VIP이용자 분들에게 새로운
            수업 이벤트를 준비했습니다. 상세한 정보를 알아보고 싶으시면 저희
            Qkids English앱에 고객 서비스 센터로 오셔서 문의하세요. Qkids
            English에 대한 지지에 감사합니다!
          </a>
          <a @click="selectSMSTEM('SMS_215343468')" id="SMS_215343468" class="list-group-item">
            <h5 class="list-group-item-heading">
              韩国VIP用户课时于近期上完，提示可再次购买课包
            </h5>
            귀한 학부모님 안녕하십니까? 저는 Qkids 고객 서비스 센터의 Angel라고
            합니다.${day}에 구매하셨던 Qkids 수업 패키지는 아이는 이미 다
            완성했습니다. 이 동안 아이는 수업에 적극적으로 참여해 주셔서
            감사합니다.부모님과 아이는 우리 수업을 좋아한다면 Qkids English에서
            계속 공부하시기를 바랍니다.수업을 다시 신청하고 싶으면
            http://qkids.com/kr/에 들어가고 수업을 직접적으로 구매하셔도
            되십니다.문제가 있으면 [Qkids English]앱에 들어가고 Qkids 고객
            서비스에게 말을 남겨 주거나 이메일로 service_kr@qkids.com 저희에게
            연락하시면 됩니다.
          </a>
          <a @click="selectSMSTEM('SMS_215305509')" id="SMS_215305509" class="list-group-item">
            <h5 class="list-group-item-heading">
              韩国体验用户-体验课4节已上完，提示可报名大课包
            </h5>
            귀한 학부모님 안녕하십니까? 저는 Qkids 고객 서비스 센터의 Angel라고
            합니다.아이는 체험 수업 4교시를 이미 완성했습니다. 아이는 너무
            잘하고 영어 공부하는 능력이 강하고 ‘북미 원어민 영어 수업’에 빠르게
            적응했습니다. 그리고 수업 시간에 적극적으로 과정를 참여했습니다.
            수업 패키지를 신청하고 싶으면 우리의 홈페이지 http://qkids.com/kr/
            에 들어가고 수업을 직접적으로 구매해도 되십니다. 문제가 있으면"Qkids
            Parents"앱에 들어가고 Qkids 고객 서비스에게 말을 남겨 주거나
            이메일로 service_kr@qkids.com 저희에게 연락하시면 됩니다.
          </a>
          <a @click="selectSMSTEM('SMS_236815410')" id="SMS_236815410" class="list-group-item">
            <h5 class="list-group-item-heading">日本-新注册用户</h5>
            Qキッズ会員にご登録いただきまして誠にありがとうございます！https://qkids.com/jpで有料体験レッスンを購入しましょう～
          </a>
          <a @click="selectSMSTEM('SMS_212270919')" id="SMS_212270919" class="list-group-item">
            <h5 class="list-group-item-heading">日本-注册未领取免费课时</h5>
            Qキッズ会員にご登録いただきまして誠にありがとうございます！https://qkids.com/jp
            で1回の無料体験レッスンを申し込みましょう～
          </a>
          <a @click="selectSMSTEM('SMS_210076594')" id="SMS_210076594" class="list-group-item">
            <h5 class="list-group-item-heading">韩国-注册未领取免费课时</h5>
            귀한 학부모님 안녕하십니까? 저는 Qkids 고객 서비스 센터의 Angel라고
            합니다. 학부모님이 ${day}에 Qkids 학습 계정을 등록하셨습니다. 지금은
            https://qkids.com/kr/ 에 들어가서 체험수업 4교시 구매할 수 있습니다.
            문제가 있으면 핸드폰에서 [Qkids Parents]앱을 다운하고 들어가서 Qkids
            고객 서비스에게 말을 남겨 주거나 이메일로 service_kr@qkids.com
            저희에게 연락하시면 됩니다.
          </a>
          <a @click="selectSMSTEM('SMS_212280777')" id="SMS_212280777" class="list-group-item">
            <h5 class="list-group-item-heading">
              日本-约课/课程确认以及安装帮助
            </h5>
            レッスンに関してご不明な点等ございましたら、スマホアプリ"Qkids
            English"の"自分"－"よくあるご質問"と"受講方法" をご覧ください。
          </a>
          <a @click="selectSMSTEM('SMS_210071609')" id="SMS_210071609" class="list-group-item">
            <h5 class="list-group-item-heading">韩国-约课通知</h5>
            귀한 학부모님 안녕하십니까? 저는 Qkids 고객 서비스 센터의 Angel라고
            합니다. 저희는 학부모님이 ${day}에 Qkids 체험 수업을 구매했습니다.
            체험 수업의 유효기간은 1개월입니다. ${passtime} 내에 사용해야
            합니다. 수업 예약을 하지 않는 것 보니 어떻게 수업을 하는지 좀
            모릅니까? 문제가 있으면 [Qkids Parents]앱에 들어가고 Qkids 고객
            서비스에게 말을 남겨 주거나 이메일로 service_kr@qkids.com 저희에게
            연락하시면 됩니다.
          </a>
          <a @click="selectSMSTEM('SMS_212275815')" id="SMS_212275815" class="list-group-item">
            <h5 class="list-group-item-heading">日本-课程确认以及安装帮助</h5>
            体験レッスンへご予約いただきありがとうございます。ご不明な点がございましたら、Ｑキッズサポートセンターかメールで問い合わせください。
          </a>
          <a @click="selectSMSTEM('SMS_210061809')" id="SMS_210061809" class="list-group-item">
            <h5 class="list-group-item-heading">韩国-课程确认以及安装帮助</h5>
            귀한 학부모님 안녕하십니까? 저는 Qkids 고객 서비스 센터의 Angel라고
            합니다. ${day} 체험 수업을 예약하신 것을 확인했습니다. 수업하기 전에
            https://qkids.com/kr/download/ 에 들어가고 앱 다운하고 마이크와
            카메라를 조정하세요. 문제가 있으면 [Qkids Parents]앱에 들어가고
            Qkids 고객 서비스에게 말을 남겨 주거나 이메일로 service_kr@qkids.com
            저희에게 연락하시면 됩니다.
          </a>
          <a @click="selectSMSTEM('SMS_212275816')" id="SMS_212275816" class="list-group-item">
            <h5 class="list-group-item-heading">日本-试听课课时过期</h5>
            体験レッスンチケットは${passtime}に期限切れになりました。こちらからシステムでもう一度チケット再発行が可能です。もしご興味がございましたら、お気軽にお問い合わせください：①
            スマホアプリ「Qkids
            English」のＱキッズサポートセンター②メールアドレス：service_jp@qkids.com。
          </a>
          <a @click="selectSMSTEM('SMS_210061810')" id="SMS_210061810" class="list-group-item">
            <h5 class="list-group-item-heading">韩国-试听课课时过期</h5>
            귀한 학부모님 안녕하십니까? 저는 Qkids 고객 서비스 센터의 Angel라고
            합니다. 체험 수업의 유효기간은 이미 ${passtime} 에 만료됐습니다.
            그래도 저희 수업을 들으시기를 원하신다면 [Qkids Parents]앱에
            들어가고 Qkids 고객 서비스에게 말을 남겨 주거나 이메일로
            service_kr@qkids.com 저희에게 연락해서 연기 신청을 해도 됩니다.
          </a>
          <a @click="selectSMSTEM('SMS_212275817')" id="SMS_212275817" class="list-group-item">
            <h5 class="list-group-item-heading">日本-试听反馈收集</h5>
            体験レッスンにご参加頂きありがとうございます。レッスンを続けたいと思ったら、https://qkids.com/jp/buy/
            でチケットをご購入できます。よろしくお願いいたします。
          </a>
          <a @click="selectSMSTEM('SMS_210061810')" id="SMS_210061810" class="list-group-item">
            <h5 class="list-group-item-heading">韩国-试听课课时过期</h5>
            귀한 학부모님 안녕하십니까? 저는 Qkids 고객 서비스 센터의 Angel라고
            합니다. 체험 수업의 유효기간은 이미 ${passtime} 에 만료됐습니다.
            그래도 저희 수업을 들으시기를 원하신다면 [Qkids Parents]앱에
            들어가고 Qkids 고객 서비스에게 말을 남겨 주거나 이메일로
            service_kr@qkids.com 저희에게 연락해서 연기 신청을 해도 됩니다.
          </a>
          <a @click="selectSMSTEM('SMS_212280781')" id="SMS_212280781" class="list-group-item">
            <h5 class="list-group-item-heading">
              日本VIP用户-华人华侨微信/邮箱引导
            </h5>
            家长您好，感谢您支持久趣课程。这边整理了孩子近期1个月在久趣的学习情况并通过客服中心给您发送了。方便的话请在"Qkids
            English"的APP上查收下哦。
          </a>
          <a @click="selectSMSTEM('SMS_210076595')" id="SMS_210076595" class="list-group-item">
            <h5 class="list-group-item-heading">
              韩国VIP用户-华人华侨微信/邮箱引导
            </h5>
            家长您好，我是久趣英语客服。非常感谢您购买我们的课包。这边总结了孩子近期1个月在久趣的学习情况。方便的话，请您添加我们的专员服务微信15396147774（韩国）或者发邮件到邮箱service_kr@qkids.com
            和我们联系哦。
          </a>
          <a @click="selectSMSTEM('SMS_212275819')" id="SMS_212275819" class="list-group-item">
            <h5 class="list-group-item-heading">日本VIP用户-家长端/邮箱引导</h5>
            お子様のために最近1ヶ月間の学習報告をまとめました。Ｑキッズサポートセンターでご査収ください。今後ともよろしくお願いします。
          </a>
          <a @click="selectSMSTEM('SMS_210071611')" id="SMS_210071611" class="list-group-item">
            <h5 class="list-group-item-heading">韩国VIP用户-家长端/邮箱引导</h5>
            귀한 학부모님 안녕하십니까? 저는 Qkids 고객 서비스 센터의 Angel라고
            합니다. 수업 패키지를 구입해 주셔서 감사합니다. 저희는 아이가 최근
            1개월 동안 Qkids에서 영어 공부와 관한 상황을 정리했습니다. 알고
            싶으시면 [Qkids Parents]앱에 들어가고 Qkids 고객 서비스에게 말을
            남겨 주거나 이메일로 service_kr@qkids.com 저희에게 연락하시면
            됩니다.
          </a>
          <a @click="selectSMSTEM('SMS_212285658')" id="SMS_212285658" class="list-group-item">
            <h5 class="list-group-item-heading">日本VIP用户-上课频率低引导</h5>
            お忙しいところを失礼いたしました。
            最近お客様はレッスンを予約していません。時間があれば、英語の感覚を鍛えるために、少なくとも週に1-2回のレッスンがオススメです。どうぞよろしくお願いいたします。
          </a>
          <a @click="selectSMSTEM('SMS_210071612')" id="SMS_210071612" class="list-group-item">
            <h5 class="list-group-item-heading">韩国VIP用户-上课频率低引导</h5>
            귀한 학부모님 안녕하십니까? 저는 Qkids 고객 서비스 센터의 Angel라고
            합니다. 계정에 아직 사용되지 않은 수업 횟수가 남아 있고 요즘 아이는
            수업 예약을 하지 않고 있습니다. 시간이 있으면 사용해 주세요. 아이는
            일정한 주파수를 유지한다면 학습 효과도 상대적으로 좋을 것입니다.
            문제가 있으면 [Qkids Parents]앱에 들어가고 Qkids 고객 서비스에게
            말을 남겨 주거나 이메일로 service_kr@qkids.com 저희에게 연락하시면
            됩니다.
          </a>
          <a @click="selectSMSTEM('SMS_210076597')" id="SMS_210076597" class="list-group-item">
            <h5 class="list-group-item-heading">
              韩国VIP用户-购买长期课后未约课
            </h5>
            귀한 학부모님 안녕하십니까? 저는 Qkids 고객 서비스 센터의 Angel라고
            합니다. ${day}에 우리 수업을 구매하셨고 아직 수업 예약하지 않았는데
            어떤 문제가 있습니까? 한대폰에서 [Qkids Parents]를 다운하고 앱에
            들어가서 Qkids 고객 서비스에게 말을 남겨 주거나 이메일로
            service_kr@qkids.com 저희에게 연락하시면 됩니다.
          </a>
          <a @click="selectSMSTEM('SMS_212285659')" id="SMS_212285659" class="list-group-item">
            <h5 class="list-group-item-heading">
              日本-特殊可单发短信（联系方式）
            </h5>
            ご不明な点等がございましたら、お気軽にお問い合わせください：①
            スマホアプリ"Qkids
            English"のＱキッズサポートセンター②メールアドレス：service_jp@qkids.com。
          </a>
          <a @click="selectSMSTEM('SMS_212280787')" id="SMS_212280787" class="list-group-item">
            <h5 class="list-group-item-heading">日本-掉线/卡顿/需要重启APP</h5>
            突然のご連絡失礼いたします。先ほどお子様と教室の接続が切れました。一度アプリを再起動してみてください。
          </a>
          <a @click="selectSMSTEM('SMS_212280788')" id="SMS_212280788" class="list-group-item">
            <h5 class="list-group-item-heading">日本-孩子未上线</h5>
            突然のご連絡失礼いたします。今日のレッスンにはお子様がまだ出席していません。何かありましたら、お気軽にお声掛けください。
          </a>
          <a @click="selectSMSTEM('SMS_212280789')" id="SMS_212280789" class="list-group-item">
            <h5 class="list-group-item-heading">
              日本-教师/声音小/上课故障等需要具体说明的问题
            </h5>
            突然のご連絡失礼いたします。レッスン中の問題をフィードバックしたいです。
            ご都合がよければ、Ｑキッズサポートセンターまでご連絡ください。
          </a>
          <a @click="selectSMSTEM('SMS_212285663')" id="SMS_212285663" class="list-group-item">
            <h5 class="list-group-item-heading">日本-缺席跟进</h5>
            突然のご連絡失礼いたします。最近お子様が欠席したことを発見しました、レッスン中のトラブルなどありましたか？お気軽にお声掛けください。
          </a>
        </a-tab-pane>
        <a-tab-pane tab="国际-日本" key="9">
          <a @click="selectSMSTEM('SMS_225995398')" id="SMS_225995398" class="list-group-item">
            <h5 class="list-group-item-heading">日本-常规通知</h5>
            突然のご連絡失礼いたします。お忙しいところ申し訳ありませんが、Qkids
            Parentsのサポートセンターでお客さまに新しいメッセージを送りました。ご確認いただけますと幸いです。どうぞよろしくお願いします。
          </a>
          <a @click="selectSMSTEM('SMS_225985415')" id="SMS_225985415" class="list-group-item">
            <h5 class="list-group-item-heading">日本-紧急联系（技术）</h5>
            突然のご連絡失礼いたします。お子様が受講しているレッスン中にトラブルが発生しました。サポートセンターまでご連絡いただければ幸いです。よろしくお願い致します。
          </a>
          <a @click="selectSMSTEM('SMS_225995402')" id="SMS_225995402" class="list-group-item">
            <h5 class="list-group-item-heading">日本-注册未领取免费课时</h5>
            Qキッズ会員にご登録いただきまして誠にありがとうございます！https://qkids.com/jp
            で1回の無料体験レッスンを申し込みましょう～
          </a>
          <a @click="selectSMSTEM('SMS_225980431')" id="SMS_225980431" class="list-group-item">
            <h5 class="list-group-item-heading">日本-未预约</h5>
            体験レッスンに関してご不明な点等ございましたら、スマホアプリ[Qkids
            Parents]の[自分]－[初心者ガイド]をご覧くださいませ。
          </a>
          <a @click="selectSMSTEM('SMS_225995418')" id="SMS_225995418" class="list-group-item">
            <h5 class="list-group-item-heading">日本-已预约</h5>
            体験レッスンをご予約いただきありがとうございます！授業の前にスマホアプリ[Qkids
            Parents]の[自分]－[初心者ガイド]をご覧くださいませ。
          </a>
          <a @click="selectSMSTEM('SMS_225990443')" id="SMS_225990443" class="list-group-item">
            <h5 class="list-group-item-heading">日本-续费引导</h5>
            レッスンにご参加頂きありがとうございます。レッスンを続けたいと思ったら、料金システム
            https://qkids.com/jp/buy/
            でレッスンチケットをご購入いただけます。よろしくお願いいたします。
          </a>
          <a @click="selectSMSTEM('SMS_225995434')" id="SMS_225995434" class="list-group-item">
            <h5 class="list-group-item-heading">日本VIP用户-上课频率低引导</h5>
            お忙しいところ申し訳ありません。最近お客様はレッスンを予約していません。語感を鍛えるため、時間があれば、週に1～2回以上のレッスンを受講することをお勧めします。どうぞよろしくお願いいたします。
          </a>
          <a @click="selectSMSTEM('SMS_225980473')" id="SMS_225980473" class="list-group-item">
            <h5 class="list-group-item-heading">日本-试听课课时过期2</h5>
            体験チケットの有効期限が切れましたが、スタッフから再発行することが可能です。ご興味のある方はお気軽にお声掛けください：1.アプリ：Qkids
            Parents‐サービス‐サポートセンター 2.メール：service_jp@qkids.com。
          </a>
          <a @click="selectSMSTEM('SMS_225985469')" id="SMS_225985469" class="list-group-item">
            <h5 class="list-group-item-heading">
              日本VIP用户-家长端/邮箱引导/特殊可单发短信（联系方式）
            </h5>
            ご不明な点等がございましたら、お気軽にお問い合わせください：1.アプリ：Qkids
            Parents‐サービス‐サポートセンター 2.メール：service_jp@qkids.com。
          </a>
          <a @click="selectSMSTEM('SMS_217435396')" id="SMS_217435396" class="list-group-item">
            <h5 class="list-group-item-heading">日本短信-新活动/通知</h5>
            突然のご連絡失礼いたします。お忙しいところ申し訳ありませんが、保護者様用アプリのＱキッズサポートセンターでお客さまに新しいメッセージを送りました。ご確認いただけますと幸いです。よろしくお願いします。
          </a>
          <a @click="selectSMSTEM('SMS_215990570')" id="SMS_215990570" class="list-group-item">
            <h5 class="list-group-item-heading">日本-注册未领取免费课时</h5>
            Qキッズ会員にご登録いただきまして誠にありがとうございます！https://qkids.com/jp
            で1回の無料体験レッスンを申し込みましょう～
          </a>
          <a @click="selectSMSTEM('SMS_215990574')" id="SMS_215990574" class="list-group-item">
            <h5 class="list-group-item-heading">
              日本-约课/课程确认以及安装帮助
            </h5>
            体験レッスンに関してご不明な点等ございましたら、スマホアプリ[Qkids
            English]の[自分]－[よくあるご質問]と[受講方法]をご覧ください。
          </a>
          <a @click="selectSMSTEM('SMS_215995559')" id="SMS_215995559" class="list-group-item">
            <h5 class="list-group-item-heading">日本-课程确认以及安装帮助</h5>
            体験レッスンへご予約いただきありがとうございます！授業の前に生徒様用アプリと保護者様用アプリをダウンロードしてください。
          </a>
          <a @click="selectSMSTEM('SMS_215990577')" id="SMS_215990577" class="list-group-item">
            <h5 class="list-group-item-heading">日本-试听课课时过期</h5>
            体験レッスンチケットの有効期限が切れました。しかし、体験チケットの再発行が可能です。もしご興味がございましたら、お気軽にお問い合わせください：①
            スマホアプリ“Qkids
            English”のＱキッズサポートセンター②メールアドレス：service_jp@qkids.com。
          </a>
          <a @click="selectSMSTEM('SMS_215985569')" id="SMS_215985569" class="list-group-item">
            <h5 class="list-group-item-heading">日本-试听反馈收集</h5>
            体験レッスンにご参加頂きありがとうございます。レッスンを続けたいと思ったら、料金システム
            https://qkids.com/jp/buy/
            でチケットパッケージをご購入いただけます。よろしくお願いいたします。
          </a>
          <a @click="selectSMSTEM('SMS_215985570')" id="SMS_215985570" class="list-group-item">
            <h5 class="list-group-item-heading">
              日本VIP用户-华人华侨微信/邮箱引导/特殊可单发短信（联系
            </h5>
            家长您好，感谢您对久趣英语课程的支持。有任何疑问或者需求，都可以随时通过“Qkids
            English”APP的客服中心与我们联系哦。
          </a>
          <a @click="selectSMSTEM('SMS_215995567')" id="SMS_215995567" class="list-group-item">
            <h5 class="list-group-item-heading">
              日本VIP用户-家长端/邮箱引导/特殊可单发短信（联系方式）
            </h5>
            ご不明な点等がございましたら、お気軽にお問い合わせください：①
            スマホアプリ[Qkids
            English]のＱキッズサポートセンター②メールアドレス：service_jp@qkids.com。
          </a>
          <a @click="selectSMSTEM('SMS_215985576')" id="SMS_215985576" class="list-group-item">
            <h5 class="list-group-item-heading">日本VIP用户-上课频率低引导</h5>
            お忙しいところを失礼いたしました。
            最近お客様はレッスンを予約していません。時間があれば、英語の語感を養うために、週に1～2回以上のレッスンを維持することをお勧めします。どうぞよろしくお願いいたします。
          </a>
          <a @click="selectSMSTEM('SMS_215980638')" id="SMS_215980638" class="list-group-item">
            <h5 class="list-group-item-heading">日本-掉线/卡顿/需要重启APP</h5>
            突然のご連絡失礼いたします。先ほどお子様と教室の接続が切れました。一度アプリを再起動してみてください。
          </a>
          <a @click="selectSMSTEM('SMS_254750097')" id="SMS_254750097" class="list-group-item">
            <h5 class="list-group-item-heading">日本-孩子未上线</h5>
            この度は、突然のご連絡失礼いたします。Qkidsのレッスンが始まりました。できるだけ早く教室に入ってください。よろしくお願い致します。
          </a>
          <a @click="selectSMSTEM('SMS_215990585')" id="SMS_215990585" class="list-group-item">
            <h5 class="list-group-item-heading">
              日本-教师/声音小/上课故障等需要具体说明的问题
            </h5>
            突然のご連絡失礼いたします。レッスン中の問題をフィードバックしたいと思います。お客様のご都合がよろしければ、Ｑキッズサポートセンターまでご連絡ください。
          </a>
          <a @click="selectSMSTEM('SMS_215980641')" id="SMS_215980641" class="list-group-item">
            <h5 class="list-group-item-heading">日本-缺席跟进</h5>
            突然のご連絡失礼いたします。最近お子様が欠席したことに気づきました、予想外のことが起きたのでしょうか。お気軽にお声掛けください。
          </a>
        </a-tab-pane>
        <a-tab-pane tab="常用-英语" key="10">
          <div>
            <a @click="selectSMSTEM('SMS_193515734')" id="SMS_193515734" class="list-group-item">
              <h5 class="list-group-item-heading">课程开课通知</h5>
              家长您好，我是您的课程顾问老师，您购买的${product}，开课时间：${day}，微信关注"久趣英语服务号"预约课程，电脑，iPad或者安卓平板均可安装上课软件。如有问题，请公众号留言或者联系我：${phone}。
            </a>
            <!-- <a
              @click="selectSMSTEM('SMS_190727926')"
              id="SMS_190727926"
              class="list-group-item"
            >
              <h5 class="list-group-item-heading">上课提醒通知</h5>
              尊敬的家长您好，由于您长时间未约课，久趣在此提醒您合理安排上课时间，避免课时包过期，小朋友的学习也是要持续跟进才能达到最好的学习效果哦~有任何问题，您可以进入“久趣英语服务号”留言咨询或联系您的专属助教老师${phone}
            </a> -->
            <a @click="selectSMSTEM('SMS_189713049')" id="SMS_189713049" class="list-group-item">
              <h5 class="list-group-item-heading">特权到账通知</h5>
              尊敬的家长，您的“${product}”已经到账，特权详情：${info}。特权使用方式：${info2}。
            </a>
            <!-- <a
              @click="selectSMSTEM('SMS_188641592')"
              id="SMS_188641592"
              class="list-group-item"
            >
              <h5 class="list-group-item-heading">顾问短信-课程有效期通知</h5>
              尊敬的家长，感谢您领取了我们久趣1节线上北美外教直播课程，由于课时只有一周的使用时间，为了避免课时到期，请尽快使用预约，我是孩子的学习顾问，有问题可以随时联系我${phone}
              或者进入久趣英语服务号留言咨询.
            </a> -->
            <a @click="selectSMSTEM('SMS_173245058')" id="SMS_173245058" class="list-group-item">
              <h5 class="list-group-item-heading">自定义特权短信</h5>
              尊敬的家长，您的${name}特权已经到账，今日付款，无需组团。
              微信公众号回复“${msg}”
              支持${proname}课程。注意事项：${info}。有疑问的地方可以联系顾问联系方式:${phone}，注意事项：${info2}
            </a>
            <a @click="selectSMSTEM('SMS_174276488')" id="SMS_174276488" class="list-group-item">
              <h5 class="list-group-item-heading">自定义特权到账</h5>
              尊敬的家长，您的${product}优惠（优惠内容:${info}）已经到账，打开”久趣英语“服务号留言“${msg}”即可使用特权。如有疑问，请联系客服热线${phone}
            </a>
            <a @click="selectSMSTEM('SMS_173345694')" id="SMS_173345694" class="list-group-item">
              <h5 class="list-group-item-heading">体验课到账</h5>
              家长您好，我是久趣英语课程老师${name}，看到您留下联系方式，想让孩子体验${product}，这边为您安排了一位专属顾问，您可以联系顾问进行详细了解，顾问联系方式是：${phone}。
            </a>
            <a @click="selectSMSTEM('SMS_173245058')" id="SMS_173245058" class="list-group-item">
              <h5 class="list-group-item-heading">特权到账</h5>
              尊敬的家长，您的${name}特权已经到账，今日付款，无需组团。
              微信公众号回复“${msg}”
              支持${proname}课程。注意事项：${info}。有疑问的地方可以联系顾问联系方式:${phone}，注意事项：${info2}
            </a>
            <a @click="selectSMSTEM('SMS_173230059')" id="SMS_173230059" class="list-group-item">
              <h5 class="list-group-item-heading">特权到账</h5>
              尊敬的家长，您的${name}特权已经到账，今日付款，无需组团。微信公众号回复“${msg}”
              支持${proname}课程。注意事项：${info}
            </a>
            <a @click="selectSMSTEM('SMS_168345588')" id="SMS_168345588" class="list-group-item">
              <h5 class="list-group-item-heading">回访提示</h5>
              家长，您好！我是久趣英语老师，您有购买我们的体验课，想跟您做一个简单的回访，以便于协助孩子更好的上课。您几点方便可以回信给我，我的手机是：${phone}
            </a>
            <a @click="selectSMSTEM('SMS_165040249')" id="SMS_165040249" class="list-group-item">
              <h5 class="list-group-item-heading">续费特权到账通知</h5>
              家长您好，久趣现有老用户续课优惠已分配到您账户，可享
              ${name}，优惠仅 24 小时内付款有效。进入“久趣英语服务号”留言
              “${msg}”
              可查看您的优惠详情。我是您孩子的学习顾问，有问题可以随时联系我
              ${phone}
            </a>
            <a @click="selectSMSTEM('SMS_164665341')" id="SMS_164665341" class="list-group-item">
              <h5 class="list-group-item-heading">续费特权到账通知</h5>
              家长您好，久趣现有老用户续课优惠已分配到您账户，可享
              ${name}。进入“久趣英语服务号”留言 “老学员续费”
              可查看您的优惠详情。！
            </a>
            <a @click="selectSMSTEM('SMS_165040169')" id="SMS_165040169" class="list-group-item">
              <h5 class="list-group-item-heading">续费优惠特权到账</h5>
              尊敬的家长，久趣英语的老用户续费特权已发送到您账户，24
              小时内使用优惠可享${name}。有问题请联系我${phone}
              或在“久趣英语服务号”留言 “${msg}”。
            </a>
            <!-- <a
              @click="selectSMSTEM('SMS_164681690')"
              id="SMS_164681690"
              class="list-group-item"
            >
              <h5 class="list-group-item-heading">约课提醒</h5>
              尊敬的家长您好，由于您长时间未约课，久趣在此提醒您合理安排上课时间，避免课时包过期，小朋友的学习也是要持续跟进才能达到最好的学习效果哦~
            </a> -->
            <!-- <a
              @click="selectSMSTEM('SMS_165117961')"
              id="SMS_165117961"
              class="list-group-item"
            >
              <h5 class="list-group-item-heading">约课通知</h5>
              您好，我是久趣英语助教老师，您于${time}购买了${name}课程，课程将于${passtime}过期。
              看您还没有约课，是否关于上课流程您有存在问题呢？有任何问题，您可以进入“久趣英语服务号”留言咨询或联系我${phone}
            </a> -->
          </div>
        </a-tab-pane>
        <a-tab-pane tab="漏话-英语" key="11">
          <div>
            <!-- <a
              @click="selectSMSTEM('SMS_167365341')"
              id="SMS_167365341"
              class="list-group-item"
            >
              <h5 class="list-group-item-heading">漏话短信-体验包过期通知</h5>
              家长您好，刚刚给您致电无人接听；您给孩子购买的${productname}的体验课包有效期是1个月，将于${expire}到期；建议合理安排下时间，给孩子预约下体验课程。我是孩子的顾问老师，有什么问题您可以直接和我联系${phone}，或在“久趣英语服务号”留言咨询
            </a> -->

            <!-- <a
              @click="selectSMSTEM('SMS_165045184')"
              id="SMS_165045184"
              class="list-group-item"
            >
              <h5 class="list-group-item-heading">
                续费优惠特权到账-课程名|顾问手机号|服务号留言内容
              </h5>
              尊敬的家长您好，我是久趣英语助教老师。您购买的${name}，将于${passtime}过期。请记得及时上课避免浪费，有疑问可以进入“久趣英语服务号”留言，或者联系我
              ${phone}(备注：${msg})，期待宝贝的进步。
            </a> -->

            <a @click="selectSMSTEM('SMS_164665602')" id="SMS_164665602" class="list-group-item">
              <h5 class="list-group-item-heading">漏话短信模板-|-带微信号</h5>
              家长你好，我是刚联系您的久趣英语顾问老师，孩子课程上的还喜欢吗？如果接下来有规划帮孩子继续上这个课程的打算的话，您可以进入“久趣英语服务号”（微信搜索公众号：jiuqufenxiang）留言，我们会有专员跟进为您服务。
            </a>

            <a @click="selectSMSTEM('SMS_164681213')" id="SMS_164681213" class="list-group-item">
              <h5 class="list-group-item-heading">
                漏话短信-课包名|顾问手机号
              </h5>
              家长你好，我是久趣英语的顾问老师，刚给您电话您没有接听。因为您是久趣英语老用户，我这边为您申请了${name}特权已经发到您账户，您可以进入“久趣英语服务号”查看，有问题的地方可以联系我手机
              ${phone}
            </a>

            <a @click="selectSMSTEM('SMS_164666556')" id="SMS_164666556" class="list-group-item">
              <h5 class="list-group-item-heading">
                付费通知-时间|课时|金额-带微信号
              </h5>
              您于${time}，购买${count}课时，总计${money}元，已完成支付。
              进入“久趣英语服务号”（微信搜索：jiuqufenxiang）获取上课帮助，若有任何问题，请拨打客服热线4008558297
            </a>
            <a @click="selectSMSTEM('SMS_167526764')" id="SMS_167526764" class="list-group-item">
              <h5 class="list-group-item-heading">漏话短信-体验课学完回访</h5>
              您好，我是孩子的专属顾问老师，这边看到孩子的体验课已经学完了，想跟您做一个简单的回访，希望您方便的时候给我回个电话，我的电话是：${phone}
            </a>
          </div>
        </a-tab-pane>
        <a-tab-pane tab="特权通知/提醒-英语" key="12" forceRender>
          <div>
            <a @click="selectSMSTEM('SMS_164665341')" id="SMS_164665341" class="list-group-item">
              <h5 class="list-group-item-heading">续费特权到账通知-课包名</h5>
              家长您好，久趣现有老用户续课优惠已分配到您账户，可享
              ${name}。进入“久趣英语服务号”留言 “老学员续费”
              可查看您的优惠详情。
            </a>

            <!-- <a
              @click="selectSMSTEM('SMS_165070733')"
              id="SMS_165070733"
              class="list-group-item"
            >
              <h5 class="list-group-item-heading">
                特权到账-课程名|公众号回复|课程详情
              </h5>
              尊敬的家长，您的${name}特权已经到账，今日付款，无需组团，另赠10课时。
              微信公众号回复“${msg}” 支持${proname}课程，半年无理由退款！
            </a> -->

            <a @click="selectSMSTEM('SMS_165040249')" id="SMS_165040249" class="list-group-item">
              <h5 class="list-group-item-heading">
                续费特权到账通知-课包名-副本
              </h5>
              家长您好，久趣现有老用户续课优惠已分配到您账户，可享
              ${name}，优惠仅 24 小时内付款有效。进入“久趣英语服务号”留言
              “${msg}”
              可查看您的优惠详情。我是您孩子的学习顾问，有问题可以随时联系我
              ${phone}
            </a>
            <a @click="selectSMSTEM('SMS_165040169')" id="SMS_165040169" class="list-group-item">
              <h5 class="list-group-item-heading">
                续费优惠特权到账-课程名|顾问手机号|服务号留言内容
              </h5>
              尊敬的家长，久趣英语的老用户续费特权已发送到您账户，24
              小时内使用优惠可享${name}。有问题请联系我${phone}
              或在“久趣英语服务号”留言 “${msg}”。
            </a>
            <!-- <a
              @click="selectSMSTEM('SMS_165117961')"
              id="SMS_165117961"
              class="list-group-item"
            >
              <h5 class="list-group-item-heading">约课通知</h5>
              您好，我是久趣英语助教老师，您于${time}购买了${name}课程，课程将于${passtime}过期。
              看您还没有约课，是否关于上课流程您有存在问题呢？有任何问题，您可以进入“久趣英语服务号”留言咨询或联系我${phone}
            </a> -->
            <!-- <a
              @click="selectSMSTEM('SMS_164681690')"
              id="SMS_164681690"
              class="list-group-item"
            >
              <h5 class="list-group-item-heading">约课提醒</h5>
              尊敬的家长您好，由于您长时间未约课，久趣在此提醒您合理安排上课时间，避免课时包过期，小朋友的学习也是要持续跟进才能达到最好的学习效果哦~
            </a> -->
            <!-- <a
              @click="selectSMSTEM('SMS_166370209')"
              id="SMS_166370209"
              class="list-group-item"
            >
              <h5 class="list-group-item-heading">试听特权通知</h5>
              您半年试听课购买名额已到账，今日报名，另赠10课时，试听如不满意，可将余下课时全款退费。公众号回复“课程报名”即可参加。
            </a> -->
            <a @click="selectSMSTEM('SMS_174990818')" id="SMS_174990818" class="list-group-item">
              <h5 class="list-group-item-heading">特权通知</h5>
              尊敬的家长，您的课程优惠特权已经到账，特权详情：24
              小时内付款，无需组团，另赠 5
              课时。特权使用方式：打开久趣英语服务号-我要报名-长期课报名，直接享受特权购买。
            </a>
          </div>
        </a-tab-pane>
        <a-tab-pane tab="其他-英语" key="13">
          <!-- <a
            @click="selectSMSTEM('SMS_184115390')"
            id="SMS_184115390"
            class="list-group-item"
          >
            <h5 class="list-group-item-heading">自然拼读课漏话短信</h5>
            家长您好，刚刚给您致电无人接听；您给孩子报名了久趣英语自然拼读直播课；建议尽快给孩子预约下体验课程。我是孩子的顾问老师，有什么问题您可以直接在“久趣英语服务号”留言咨询，或和我联系${phone}
          </a> 
          <a
            @click="selectSMSTEM('SMS_184105390')"
            id="SMS_184105390"
            class="list-group-item"
          >
            <h5 class="list-group-item-heading">自然拼读课约课方式</h5>
            家长您好，久趣自然拼读约课方式：微信搜索关注“久趣英语服务号”公众号-预约上课-辅修课-自然拼读大班直播课-选择合适的上课时间即可。电脑下载软件地址：www.qkids.cn。ipad下载”久趣英语2.0“即可。有问题留言公众号哦~
          </a>
          <a
            @click="selectSMSTEM('SMS_183266028')"
            id="SMS_183266028"
            class="list-group-item"
          >
            <h5 class="list-group-item-heading">公益课约课方式</h5>
            家长您好，久趣公益课约课方式：微信搜索关注“久趣英语服务号”公众号-预约上课-公益课约课--选择合适的主题、难度、上课时间即可。电脑下载地址：www.qkids.cn。ipad下载久趣英语2.0即可。有问题留言公众号哦
          </a>
          <a
            @click="selectSMSTEM('SMS_183265815')"
            id="SMS_183265815"
            class="list-group-item"
          >
            <h5 class="list-group-item-heading">公益课购买</h5>
            家长您好，刚刚给您致电无人接听；您给孩子领取公益课有效期是截至本月的29号的；建议合理安排下时间，给孩子预约下体验课程。我是孩子的顾问老师，有什么问题您可以直接在“久趣英语服务号”留言咨询，或和我联系${phone}
          </a>-->
          <a @click="selectSMSTEM('SMS_178766381')" id="SMS_178766381" class="list-group-item">
            <h5 class="list-group-item-heading">客服-快手购买</h5>
            您好，您有在快手直播中购买了《50元4节体验课》已经付款，您可以尽快联系客服，完成课时兑换和定级哈。客服联系方式:${phone}
          </a>
          <a @click="selectSMSTEM('SMS_171118132')" id="SMS_171118132" class="list-group-item">
            <h5 class="list-group-item-heading">顾问-教师安排</h5>
            家长，您好！感谢您购买了${product}，为了帮助孩子更好的规划课程学习，这边为您匹配了您的专属课程规划师${teacher}老师，她将负责宝贝在久趣的学习。请注意保存课程老师的联系方式(注意事项:${info})，老师将为宝贝做入学初步课程分级。老师的手机号是：${phone}
          </a>
          <a @click="selectSMSTEM('SMS_165106132')" id="SMS_165106132" class="list-group-item">
            <h5 class="list-group-item-heading">主题课购买通知</h5>
            您于${time}，购买${name}，总计${money}元，已完成支付。课程有效期为：${begintime}到${endtime}，请及时进入“久趣英语服务号”（微信搜索：jiuqufenxiang）获取上课帮助，若有任何问题，请拨打客服热线4008558297或在服务号留言。
          </a>
          <a @click="selectSMSTEM('SMS_164590086')" id="SMS_164590086" class="list-group-item">
            <h5 class="list-group-item-heading">付费通知-时间|课时|金额</h5>
            您于${time}，购买${count}课时，总计${money}元，已完成支付。
            进入“久趣英语服务号”获取上课帮助，若有任何问题，请拨打客服热线4008558297
          </a>
          <a @click="selectSMSTEM('SMS_164680305')" id="SMS_164680305" class="list-group-item">
            <h5 class="list-group-item-heading">支付成功通知-金额-带微信号</h5>
            您已成功支付${money}元。进入“久趣英语服务号”（微信搜索：jiuqufenxiang）了解订单详情，若有任何问题，请拨打客服热线4008558297。
          </a>
          <a @click="selectSMSTEM('SMS_164680595')" id="SMS_164680595" class="list-group-item">
            <h5 class="list-group-item-heading">链接-课包名|自定义链接</h5>
            家长您好，您的${name}特权购买名额已经到账，点击链接了解特权详情：https://wx2.97kid.com/wx/${code}
          </a>
          <a @click="selectSMSTEM('SMS_164680319')" id="SMS_164680319" class="list-group-item">
            <h5 class="list-group-item-heading">
              特权到账通知-课包名-固定链接
            </h5>
            家长您好，您的${name}特权购买名额已经到账，点击链接了解特权详情：https://wx2.97kid.com/wx/1vip
          </a>
          <a @click="selectSMSTEM('SMS_164681483')" id="SMS_164681483" class="list-group-item">
            <h5 class="list-group-item-heading">
              特权通知-课包名|自定义链接（域名后缀）
            </h5>
            家长您好，您的${name}特权购买名额已经到账，点击链接了解特权详情：https://wx2.97kid.com/${code}
          </a>
          <a @click="selectSMSTEM('SMS_170115777')" id="SMS_170115777" class="list-group-item">
            <h5 class="list-group-item-heading">顾问-课前上课提醒</h5>
            家长你好，来电提醒您预约了久趣的英语课程，记得提前5分钟进入教室上课。预约上课的时间在久趣英语服务号底下，预约上课，课表里面查询。
          </a>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
  import vuex from "@/store.js";
  import { get } from "@/api/axios.js";

  export default {
    name: "SMSView",
    data: () => {
      return {
        SmsList: {}
      };
    },
    methods: {
      selectSMSTEM: function (code) {
        let texthtml = document
          .getElementById(code)
          .innerHTML.split("</h5>")[1]
          .split(" ")
          .join("")
          .split("\n")
          .join("");
        console.log(code, texthtml);
        vuex.state.smsBody.smsCode = code;
        vuex.state.smsBody.smsText = texthtml;
        var re = /(\$\{\w{3,15}\})/g;
        var tempR = texthtml.match(re);
        vuex.state.smsBody.smsHtml = "";
        vuex.state.smsBody.smsParams = [];
        if (tempR != null && tempR.length > 0) {
          tempR.forEach(function (item) {
            var subItem = item.substring(2, item.length - 1);
            console.log(subItem);
            vuex.commit("addSmsParam", subItem);
            // this.$store.state.smsBody.smsParams.push(subItem)
            vuex.state.smsBody.smsHtml +=
              '<div class="input-group" style="margin-top: 20px">\n' +
              '            <span class="input-group-addon" >' +
              item +
              "</span>\n" +
              '            <input class="ant-input" style="width:200px" type="text" id="param_' +
              subItem +
              '" value="" \'>\n' +
              '<span class="input-group-addon" id="param_' +
              subItem +
              'badge"></span>' +
              "        </div>";
          });
        }
      },
      tabCallback (key) { }
    },
    created: function () {
      get("/getAllSmsTemplates")
        .then(res => {
          console.log(res.data);
          this.SmsList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  };
</script>
<style scoped>
  a.list-group-item {
    color: #555;
    text-decoration: none;
    position: relative;
    display: block;
    padding: 10px 15px;
    margin-bottom: 0px;
    background-color: #fff;
    border: 1px solid #ddd;
  }
</style>